export const detectGtmData = () => {
  const hostname = window.location.hostname

  if (/www\.jpujol\.com/.test(hostname)) {
    return true
  }
  if (/www\.elna-jpujol\.com/.test(hostname)) {
    return true
  }
  if (/www\.ideaspatch\.com/.test(hostname)) {
    return true
  }
  if (/www\.necchi-jpujol\.com/.test(hostname)) {
    return true
  }
  if (/www\.handiquilter-jpujol\.com/.test(hostname)) {
    return true
  }
  if (/www\.jack-jpujol\.com/.test(hostname)) {
    return true
  }
  if (/www\.juki-jpujol\.com/.test(hostname)) {
    return true
  }

  return false
}
